<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Unidade Temática
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="content.nome"
                  label="Unidade Temática"
                  readonly
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="habilidadesFormatadas"
                  label="Código da Habilidade"
                  readonly
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <span class="small"><v-icon small>mdi-gesture-double-tap</v-icon> Habilidade(s) Selecionada(s)</span>
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="(habilidade, i) in content.habilidades" :key="i" @click="selecionarChip(habilidade)">
                    <v-icon small>mdi-checkbox-marked-circle-outline</v-icon> {{ habilidade.codigo }}
                  </v-chip>
                </v-chip-group>
                <span v-if="descricaoCodigoSelecionado">
                  <span class="small"><v-icon small>mdi-alert-circle-check-outline</v-icon> Informações da Habilidade Selecionada</span>
                  <v-chip-group column>
                    <v-chip>{{ descricaoCodigoSelecionado }}</v-chip>
                  </v-chip-group>
                </span>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <v-textarea
                  v-model="content.descricao"
                  label="O que será avaliado"
                  maxlength="2500"
                  readonly
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 2500)]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { PraticaLinguagem } from '~/commons/classes/pratica-linguagem';

export default {
  props: new DialogProps(PraticaLinguagem),
  data: () => ({
    descricaoCodigoSelecionado: null
  }),
  computed: {
    habilidadesFormatadas() {
      return this.content.habilidades.map(v => v.codigo).join(' / ');
    }
  },
  methods: {
    selecionarChip(codigo) {
      this.descricaoCodigoSelecionado = (this.descricaoCodigoSelecionado === codigo?.descricao) ? null : codigo?.descricao;
    }
  }
};
</script>
